import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { noLongerCuratedBox } from 'routes/Menu/actions/menuRecipeDetails'
import { getRecipesInCuratedBoxCollection } from 'routes/Menu/selectors/collections'

export const useCheckRecipeInCuratedBoxCollection = () => {
  const dispatch = useDispatch()
  const recipeIdsInCuratedBoxCollection = useSelector(getRecipesInCuratedBoxCollection)

  return useCallback(
    (recipeId: string) => {
      if (!recipeIdsInCuratedBoxCollection?.size) return

      const isRecipeInCuratedBoxCollection = recipeIdsInCuratedBoxCollection
        .toJS()
        .includes(recipeId)

      if (!isRecipeInCuratedBoxCollection) {
        dispatch(noLongerCuratedBox())
      }
    },
    [dispatch, recipeIdsInCuratedBoxCollection],
  )
}
